import { useState } from "react";

export default function Attendance() {

  const studentsData = [
    { id: 17, name: "Rahul", className: "10-A", rollNo: "101" },
    { id: 18, name: "Sneha", className: "10-A", rollNo: "102" },
    { id: 19, name: "Kiran", className: "9-B", rollNo: "103" },
    { id: 1, name: "Priya", className: "9-B", rollNo: "104" },
    { id: 2, name: "Sneha Sharma", className: "9-B", rollNo: "105" },
    { id: 3, name: "Ram Sharma", className: "9-B", rollNo: "106" },
    { id: 4, name: "Vijay Sharma", className: "9-B", rollNo: "107" },
    { id: 5, name: "Ravi Sharma", className: "9-B", rollNo: "108" },
    { id: 6, name: "Amit Sharma", className: "9-B", rollNo: "109" },
    { id: 7, name: "Deepak Sharma", className: "9-B", rollNo: "110" }
  ];

  const [selectedClass, setSelectedClass] = useState("");
  const [selectedDate, setSelectedDate] = useState(
    new Date().toISOString().split("T")[0]
  );

  const [attendance, setAttendance] = useState({});
  const [savedRecords, setSavedRecords] = useState([]);

  const classes = [...new Set(studentsData.map(s => s.className))];

  const filteredStudents = studentsData.filter(
    student => student.className === selectedClass
  );

  const handleMark = (studentId, status) => {
    setAttendance(prev => ({
      ...prev,
      [studentId]: status
    }));
  };

  const markAll = (status) => {
    const newAttendance = {};
    filteredStudents.forEach(student => {
      newAttendance[student.id] = status;
    });
    setAttendance(newAttendance);
  };

  const handleSave = () => {

    const alreadyMarked = savedRecords.find(
      record =>
        record.className === selectedClass &&
        record.date === selectedDate
    );

    if (alreadyMarked) {
      alert("Attendance already marked for this class and date!");
      return;
    }

    const newRecord = {
      className: selectedClass,
      date: selectedDate,
      records: filteredStudents.map(student => ({
        studentId: student.id,
        name: student.name,
        rollNo: student.rollNo,
        status: attendance[student.id] || "Absent"
      }))
    };

    setSavedRecords([...savedRecords, newRecord]);
    alert("Attendance saved successfully!");
  };

  const presentCount = Object.values(attendance).filter(
    status => status === "Present"
  ).length;

  const totalStudents = filteredStudents.length;

  const percentage =
    totalStudents > 0
      ? ((presentCount / totalStudents) * 100).toFixed(1)
      : 0;

  return (
    <div>

      <h2 className="text-2xl font-bold mb-6">
        Mark Attendance
      </h2>

      {/* Controls */}

      <div className="flex flex-col md:flex-row gap-4 mb-6">

        <select
          className="px-4 py-2 border rounded"
          value={selectedClass}
          onChange={(e) => {
            setSelectedClass(e.target.value);
            setAttendance({});
          }}
        >
          <option value="">Select Class</option>

          {classes.map((cls, index) => (
            <option key={index} value={cls}>
              {cls}
            </option>
          ))}

        </select>

        <input
          type="date"
          className="px-4 py-2 border rounded"
          value={selectedDate}
          max={new Date().toISOString().split("T")[0]}
          onChange={(e) => setSelectedDate(e.target.value)}
        />

      </div>

      {/* MAIN GRID */}

      <div className="grid grid-cols-1 lg:grid-cols-5 gap-6">

        {/* LEFT SIDE */}

        <div className="lg:col-span-3">

          {selectedClass && (
            <>

              {/* Bulk Actions */}

              <div className="flex gap-4 mb-4 items-center">

                <button
                  onClick={() => markAll("Present")}
                  className="bg-green-600 text-white px-4 py-2 rounded"
                >
                  Mark All Present
                </button>

                <button
                  onClick={() => markAll("Absent")}
                  className="bg-red-600 text-white px-4 py-2 rounded"
                >
                  Mark All Absent
                </button>

                <button
                  onClick={handleSave}
                  className="bg-blue-600 text-white px-4 py-2 rounded"
                >
                  Save Attendance
                </button>

              </div>


              {/* Attendance Table */}

              <div className="bg-white shadow rounded-xl overflow-hidden">

                <table className="w-full text-left">

                  <thead className="bg-gray-100">
                    <tr>
                      <th className="p-4">Student Name</th>
                      <th className="p-4 text-center">Present</th>
                      <th className="p-4 text-center">Absent</th>
                    </tr>
                  </thead>

                  <tbody>

                    {filteredStudents.map(student => (

                      <tr key={student.id} className="border-t">

                        <td className="p-4 font-semibold">
                          {student.name}
                        </td>

                        <td className="p-4 text-center">

                          <input
                            type="radio"
                            name={`attendance-${student.id}-${selectedDate}`}
                            onChange={() => handleMark(student.id, "Present")}
                            checked={attendance[student.id] === "Present"}
                          />

                        </td>

                        <td className="p-4 text-center">

                          <input
                            type="radio"
                            name={`attendance-${student.id}-${selectedDate}`}
                            onChange={() => handleMark(student.id, "Absent")}
                            checked={attendance[student.id] === "Absent"}
                          />

                        </td>

                      </tr>

                    ))}

                  </tbody>

                </table>

              </div>

            </>
          )}

        </div>


        {/* RIGHT SIDE */}

        <div className="lg:col-span-2">

          <div className="bg-white shadow rounded-xl p-4">

            <h3 className="text-lg font-bold mb-4">
              Attendance Summary
            </h3>


            {/* Summary Cards */}

            <div className="grid grid-cols-3 gap-3 mb-3">

              <div className="bg-green-50 p-3 rounded text-center">
                <p className="text-sm text-gray-500">Present</p>
                <p className="text-lg font-bold">{presentCount}</p>
              </div>

              <div className="bg-red-50 p-3 rounded text-center">
                <p className="text-sm text-gray-500">Absent</p>
                <p className="text-lg font-bold">
                  {totalStudents - presentCount}
                </p>
              </div>

              <div className="bg-blue-50 p-3 rounded text-center">
                <p className="text-sm text-gray-500">%</p>
                <p className="text-lg font-bold">{percentage}%</p>
              </div>

            </div>


            {/* Total Students */}

            <div className="text-center mb-4 font-semibold">
              Total Students : {totalStudents}
            </div>


            {/* History Table */}

            <div className="max-h-80 overflow-y-auto">

              <table className="w-full text-sm">

                <thead className="bg-gray-100">
                  <tr>
                    <th className="p-2 text-left">Roll</th>
                    <th className="p-2 text-left">Name</th>
                    <th className="p-2 text-left">Status</th>
                  </tr>
                </thead>

                <tbody>

                  {filteredStudents.map(student => {

                    const status =
                      attendance[student.id] || "Absent";

                    return (

                      <tr key={student.id} className="border-t">

                        <td className="p-2">
                          {student.rollNo || "-"}
                        </td>

                        <td className="p-2">
                          {student.name}
                        </td>

                        <td className="p-2">

                          <span
                            className={`px-2 py-1 text-xs rounded
                              ${status === "Present"
                                ? "bg-green-100 text-green-700"
                                : "bg-red-100 text-red-700"
                              }`}
                          >
                            {status}
                          </span>

                        </td>

                      </tr>

                    );

                  })}

                </tbody>

              </table>

            </div>

          </div>

        </div>

      </div>

    </div>
  );
}